export default __webpack_public_path__ + "static/media/Outer-layer.c0a5f575.png";